import { render, staticRenderFns } from "./NegocioOrcamentosPesquisar.vue?vue&type=template&id=67472e91&scoped=true&"
import script from "./NegocioOrcamentosPesquisar.vue?vue&type=script&lang=js&"
export * from "./NegocioOrcamentosPesquisar.vue?vue&type=script&lang=js&"
import style0 from "./NegocioOrcamentosPesquisar.vue?vue&type=style&index=0&id=67472e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67472e91",
  null
  
)

export default component.exports